module.exports = __webpack_public_path__ + "static/media/PaymentSuccess.1a9379a8.png";